import { render } from "./simulate-pay-popup.vue?vue&type=template&id=64ac92a4&scoped=true"
import script from "./simulate-pay-popup.vue?vue&type=script&lang=js"
export * from "./simulate-pay-popup.vue?vue&type=script&lang=js"

import "./simulate-pay-popup.vue?vue&type=style&index=0&id=64ac92a4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64ac92a4"]])

export default __exports__